export default "__VITE_ASSET__vlXbkj1j__"